import { useContext } from 'react'
import { observer } from 'mobx-react'
import { Form, Button } from 'antd'
import { LoadableControl, ListSearchContext } from 'src/components'
import { $consts } from 'src/plugins'

const ListSearchExpand = () => {
  const search = useContext(ListSearchContext)

  const handleQuerySwitch = (key: string) => {
    search.setActiveKey(key)
    search.search()
  }

  return (
    <div className='list-search__expand-search'>
      {
        search.expandSearch.length
          ? (
            <Form layout='inline'>
              {
                search.expandSearch.map((item: any, index: number) => {
                  return (
                    <LoadableControl
                      key={`${item.ID}_${index}`}
                      pageType={$consts['TABLE/FORM_TYPE_LIST_PAGE']}
                      locateControl={$consts['TABLE/CONTROL_LOCATE_HEADER']}
                      config={item}
                    />
                  )
                })
              }
            </Form>
          )
          : null
      }
      {search.expandSearch.length && search.searchConfig.Nav_FormQuery?.length ? <div className='mg-t4 mg-b4' /> : null}
      {
        search.searchConfig.Nav_FormQuery?.length >= 2
          ? (
            <Form layout='inline'>
              <Form.Item label='查询切换'>
                {
                  search.searchConfig.Nav_FormQuery.map((item: any) => {
                    return (
                      <Button
                        size='small'
                        type={item.ID === search.activeKey ? 'primary' : 'default'}
                        onClick={() => handleQuerySwitch(item.ID)}
                        className='mg-r4'
                      >{item.LABEL}</Button>
                    )
                  })
                }
              </Form.Item>
            </Form>
          )
          : null
      }
    </div>
  )
}

export default observer(ListSearchExpand)